import type { IFormxRepository, FormListOptions } from '../repositories/IFormxRepository.js';
import type { FormxFormEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxFormsUseCase({ formxRepository }: Deps) {
  return async function listFormxForms(options: FormListOptions): Promise<{ data: FormxFormEntity[]; total: number }> {
    return formxRepository.listForms(options);
  };
}
